// Utility functions for breadcrumb navigation

export const getBreadcrumbInfo = (pathname) => {
  const breadcrumbMap = {
    
    // Time Records
    '/stores/admin': { category: 'Dashboard', page: 'Time Records' },
    
    // Activity Logs
    '/stores/admin-activity-logs': { category: 'Dashboard', page: 'Activity Logs' },
    
    // User Management
    '/stores/user': { category: 'User Management', page: 'Users' },
    '/stores/archive': { category: 'User Management', page: 'Archived Users' },
    '/stores/adjustment': { category: 'User Management', page: 'Time Adjustment' },
    '/stores/schedule': { category: 'User Management', page: 'Schedules' },
    
    // Access & Authentication
    '/stores/qr': { category: 'Access & Authentication', page: 'QR Code' },
    '/stores/biometric': { category: 'Access & Authentication', page: 'Biometrics' },
    
    // Communication  
    '/stores/announcements': { category: 'Communication', page: 'Announcements' },
    '/stores/reports': { category: 'Communication', page: 'Reports' },
    
    // Company Tools
    '/stores/breaklist-info': { category: 'Company Tools', page: 'Breaklist Summary' },
    '/stores/manage-breaklist': { category: 'Company Tools', page: 'Edit Breaklist' },
    '/stores/breaklist': { category: 'Company Tools', page: 'Generated Breaklist' },
    '/stores/video-tutorials': { category: 'Company Tools', page: 'Video Tutorials' },
    '/stores/admin-company': { category: 'Company Tools', page: 'My Company' },
    '/stores/required-documents': { category: 'Company Tools', page: 'Required Documents' },
    '/stores/training-development': { category: 'Company Tools', page: 'Training And Development' },
    '/stores/dice-game': { category: 'Company Tools', page: 'Dice Game' },
    
    // Additional pages
    '/stores/approval': { category: 'Dashboard', page: 'Store Approval' },
    '/stores/feedbacks': { category: 'Communication', page: 'Feedbacks' },
    '/stores/holidays': { category: 'Company Tools', page: 'Holidays' },
    '/stores/features': { category: 'Dashboard', page: 'Features' },
  };

  return breadcrumbMap[pathname] || { category: 'Dashboard', page: 'Unknown' };
};

export const getCategoryColor = (category) => {
  const colorMap = {
    'Dashboard': '#2FB7DE',
    'User Management': '#23A6DC', 
    'Access & Authentication': '#1F99DC',
    'Communication': '#4BBDE3',
    'Company Tools': '#63CCE7',
  };
  
  return colorMap[category] || '#2FB7DE';
};